import { RatingForm, SuccessAlert } from '@/components';
import { RATINGS } from '@/utils/strings';
import { FC } from 'react';
import {
  GENERAL_RATINGS,
  RatingDefinition,
  RatingFormType,
  YIELD_BEARING_ASSET_RATINGS,
} from '../RatingForm/RatingForm';
interface RatingFormAlertProps {
  type?: RatingFormType;
  ticker?: string;
  ratingTypes?: RatingDefinition[];
  title?: string;
  description?: string;
  onRatingPosted?: () => void;
}
const RatingFormAlert: FC<RatingFormAlertProps> = ({
  type,
  ticker,
  ratingTypes,
  title = RATINGS.SECTION_TITLE,
  description = RATINGS.SECTION_DESCRIPTION,
  onRatingPosted: ratingPostedHandler,
}) => {
  const derivedType = ticker
    ? RatingFormType.YIELD_BEARING_ASSET
    : type || RatingFormType.GENERAL;
  const derivedRatingTypes =
    ratingTypes || (ticker ? YIELD_BEARING_ASSET_RATINGS : GENERAL_RATINGS);
  return (
    <SuccessAlert
      title={title}
      description={description}
      extraContent={
        <div className="flex w-full pt-3">
          <RatingForm
            type={derivedType}
            ticker={ticker}
            ratingTypes={derivedRatingTypes}
            onRatingPosted={ratingPostedHandler}
          />
        </div>
      }
    />
  );
};
export default RatingFormAlert;
